import React from 'react';
import { Restaurant } from '../types';
import RestaurantCard from './RestaurantCard';

interface RestaurantListProps {
  restaurants: Restaurant[];
}

const RestaurantList: React.FC<RestaurantListProps> = ({ restaurants }) => {
  return (
    <div className="border-t border-black/5">
      {restaurants
        .slice()
        .sort((a, b) => a.rank - b.rank)
        .map((restaurant, index) => (
          <div
            key={restaurant.placeId ?? restaurant.rank}
            className="animate-slide-up opacity-0"
            style={{
              animationDelay: `${index * 100}ms`,
              animationFillMode: 'forwards'
            }}
          >
            <RestaurantCard restaurant={restaurant} />
          </div>
        ))}
    </div>
  );
};

export default RestaurantList;
